export default __webpack_public_path__ + "static/colibri-2-web-f039724a044ed9f1b19aed9aef3fd7ac.pdf";